<template>
  <div class="admin flex flex-col items-center bg-wild-sand pb-3 pt-6 sm:px-6">
    <BasePanel class="bg-white w-full max-w-6xl">
      <BasePanelHeader class="flex relative justify-between items-center">
        <span class="font-semibold text-abbey text-sm">Admin Actions</span>
      </BasePanelHeader>

      <div class="flex flex-col flex-1 px-4 py-5">
        <div class="flex flex-col">
          <RouterLink
            v-if="false"
            class="flex text-xs text-deep-cerulean hover:underline items-center h-8"
            :to="{ name: 'admin.cancel' }"
            >Cancel</RouterLink
          >
          <RouterLink
            class="flex text-xs text-deep-cerulean hover:underline"
            :to="{ name: 'admin.delete' }"
            >Delete Action Items</RouterLink
          >
        </div>
      </div>
    </BasePanel>
  </div>
</template>

<script>
export default {
  name: 'Admin'
}
</script>
